import { gql } from "@apollo/client";

export const MeetingHeaderFragment = gql`
  fragment MeetingHeaderFragment on MeetingNode {
    id
    title
    startDatetime
    meetingGroupId
    draft
    isRecurring
  }
`;

export default gql`
  ${MeetingHeaderFragment}
  query getPreviousMeetingsQuery(
    $meetingGroupId: Int
    $subject: Int
    $beforeDate: DateTime!
    $maxFutureDate: DateTime!
    $after: String
    $limit: Int!
    $draft: Boolean
    $ignored: Boolean
  ) {
    meetings(
      meetingGroupId: $meetingGroupId
      subject: $subject
      startDatetime_Lte: $beforeDate
      first: $limit
      after: $after
      orderBy: "-start_datetime"
      draft: $draft
      ignored: $ignored
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...MeetingHeaderFragment
        }
      }
    }
    nextMeetings: meetings(
      meetingGroupId: $meetingGroupId
      subject: $subject
      startDatetime_Gte: $beforeDate
      startDatetime_Lte: $maxFutureDate
      first: 65
      orderBy: "start_datetime"
      draft: $draft
      ignored: $ignored
    ) {
      edges {
        node {
          ...MeetingHeaderFragment
        }
      }
    }
  }
`;
